import React from 'react';

const Page404 = () => {
   return (
      <div className='text-center absolute-center'>
         <h1 className='display-1 font-weight-bold'>404</h1>
         <p className='h1'>Page not found.</p>
         <p className='h2 font-weight-normal mt-3 mb-4'>
            The page you are looking for might have been removed.
         </p>
      </div>
   );
};

export default Page404;
